import ReactDOM from 'react-dom/client';
import { v2Component } from '../../index';
import { OrderList } from './order-list';
import { AdminContextProvider } from '../../context/admin-context';
import { ToastContainer } from 'react-toastify';

export function initOrdersView() {
  document.getElementsByName('orders-view').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        root.render(
          v2Component(
            <AdminContextProvider>
              <ToastContainer />
              <OrderList />
            </AdminContextProvider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
